<template>
<pt-form-list-item v-if="!filed.hidden" :label="textOfTip?(filed.label+textOfTip):filed.label+'：'" :required="!!required">
    <component  :class="type==='pt-address-select'?$style['address-selector']:null" :is="type" :options="options" v-model="currentValue" :showElement="showElement" :title="filed.label"
    :type="filed.fieldType === 'DATE'?dateType:filedSubType" v-validate="required||filed.validation" :data-vv-as="filed.label" :data="options"
    :placeholder="placeholder" :col="options.length" :propObj="{text:'label'}" :allowSearch="allowSearch" :disabled="disabled"
    :businessType="filed.fieldType === 'ADDRESS_SELECT'?addressBusinessType:null" :picker-options="pickerOptionsStart" value-format="timestamp">
    </component>
</pt-form-list-item>
</template>
<script>
import ptAddressSelect from 'cps/base/pt-address-select/withData'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    filed: {
      type: Object,
      default: function () {
        return {
        }
      }
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: ''
    },
    defaultData: {
      type: Object,
      default: function () {
        return {}
      }

    },
    reportDetail: {
      type: Object
    },
    isEdit: {
      type: Boolean
    },
    addressBusinessType: {
      type: String
    },
    isCuderRadioClasses: {
      type: Boolean
    },
    isSpecalActiveSign: {
      type: Boolean
    },
    isAnniversarySign: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ptAddressSelect
    // ptBtnFilter
  },
  data () {
    return {
      formValue: {},
      // type: 'wt-' + this.filed.fieldType,
      // options: this.filed.options || [],
      key: this.filed.key,
      datePicker: null,
      // required: this.filed.required,
      placeholder: this.filed.fieldType === 'ADDRESS_SELECT' ? '请选择省市区县' : this.filed.label,
      currentValue: (this.filed.fieldType === 'ADDRESS_SELECT' || this.filed.fieldType === 'CHECKBOX') ? (this.value ? this.value : []) : this.value,
      allowSearch: false,
      valueDate: null,
      textOfTip: null,
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.filed.startDate && time < this.filed.startDate) {
            return true
          } else if (time < new Date().getTime()) {
            return true
          }
        }
      },
      dateCeshi: 1595347200000,
      showElement: undefined,
      dateType: 'date'
    }
  },
  watch: {
    value: {
      handler: function () {
        this.valueData()
      },
      immediate: true
    },
    currentValue (val) {
      let data = val
      if (this.filed.fieldType === 'SELECT') {
        if (val) {
          this.options.forEach(item => {
            if (item.value === val) {
              if (this.filed.optionsEnum === 'hospital' || this.filed.optionsEnum === 'lifeExperienceHall' || this.filed.optionsEnum === 'lifeExperienceHallVisit') {
                data = {}
                data.id = val
                data.name = item.text
              }
            }
          })
        }
      }
      if (this.filed.fieldType === 'DATE') {
        // data = this.valueDate
        this.setDate(val)
      }
      this.formValue[this.key] = val
      this.$emit('input', data)
    },
    'filed.optionsEnum': {
      handler: function (val) {
        if (val && val === 'hospital') {
          // this.allowSearch = true
        }
      },
      immediate: true
    },
    'filed.multiple': {
      handler: function (val) {
        if (val) {
          this.textOfTip = '(可多选)'
        } else {
          this.textOfTip = null
        }
      },
      immediate: true
    },
    defaultData (val) {
      if (this.filed.autoFill) {
        this.currentValue = this.filed.autoFill ? val[this.filed.autoFill] : null
      }
    },
    'filed.autoFill': {
      handler: function (val) {
        if (this.value && this.isEdit) {
          this.valueData()
        } else {
          this.currentValue = val ? this.defaultData[val] : ((this.filed.fieldType === 'ADDRESS_SELECT' || this.filed.fieldType === 'CHECKBOX' || (this.filed.fieldType === 'SELECT' && this.filed.multiple)) ? [] : null)
        }
        // this.currentValue = this.value ? this.value : (val ? this.defaultData[val]
        //   : (this.filed.fieldType === 'ADDRESS_SELECT' || this.filed.fieldType === 'CHECKBOX' ? (this.value ? this.value : []) : this.value))
        // if (this.filed.fieldType === 'DATE' && this.value && this.isEdit) {
        //   // this.$set(this, 'currentValue', formatDate(this.value, 'YYYY-MM-DD'))
        //   this.valueDate = this.value
        // }
      },
      immediate: true
    }
  },
  computed: {
    // item的class
    disabled () {
      return this.filed.disabled
    },
    // 是否是体验馆参观活动并且是参观时间字段（限制时间可选）
    timeOfVisit () {
      return this.filed.key === 'parseDate' && this.isSpecalActiveSign
    },
    startDate () {
      let startDate = this.filed.startDate || new Date()
      return startDate
    },
    options () {
      if (this.filed.options && this.filed.options.length) {
        if (this.filed.fieldType === 'SELECT') {
          this.filed.options.forEach(item => {
            item.text = item.text || item.label
          })
        }
        if (this.type === 'wt-checkbox') {
          this.filed.options.forEach(item => {
            item.text = item.label
          })
        }
      }
      return this.filed.options || []
    },
    // 是否显示下拉选择的右边下箭头
    showDown () {
      return this.filed.fieldType === 'SELECT' && !this.filed.multiple
    },
    type () {
      let filed = null
      switch (this.filed.fieldType) {
        case 'INPUT':
          filed = 'wt-input'
          break
        case 'TEXTARE':
          filed = 'cube-textarea'
          break
        case 'SELECT':
          // if (this.filed.multiple) {
          //   filed = 'wt-checkbox'
          // } else {
          filed = 'wt-selector'
          // }
          break
        case 'RADIO':
          if (this.isCuderRadioClasses) {
            filed = 'cube-radio-group'
          } else {
            filed = 'wt-radio'
          }
          break
        case 'CHECKBOX':
          filed = 'wt-checkbox'
          break
        case 'ADDRESS_SELECT':
          filed = 'pt-address-select'
          break
        case 'DATE':
          filed = 'el-date-picker'
          break
        default:
          filed = 'wt-input'
      }
      return filed
    },
    filedSubType () {
      let type = null
      switch (this.filed.fieldType) {
        case 'RADIO':
          type = 'radio'
          break
        case 'INPUT':
          switch (this.filed.fieldSubType) {
            case 'math':
              type = 'number'
              break
            default:
              type = 'text'
          }
          break
        default:
          type = ''
      }
      return type
    },
    required () {
      let required = null
      if (this.filed.required) {
        required = 'required' + (this.filed.validation === 'identityCard' ? '|idcard' : (this.filed.validation ? '|' + this.filed.validation : ''))
        if ((this.filed.fieldType === 'SELECT' || this.filed.fieldType === 'CHECKBOX') && this.filed.multiple) {
          required = 'requiredArray'
        } else {
          switch (this.filed.key) {
            case 'phone':
              required = 'required|phone'
              break
            default:
              required = required || 'required'
          }
        }
      }
      return required
    },
    validation () {
      return this.filed.validation === 'dentityCard' ? 'idcard' : null
    }
  },
  methods: {
    // 清空日期选择的内容
    emptyDate (key) {
      if (key === this.filed.key) {
        this.currentValue = null
      }
    },
    // 读入数据处理
    valueData () {
      if (this.filed.fieldType === 'ADDRESS_SELECT' || this.filed.fieldType === 'CHECKBOX') {
        if (this.isAnniversarySign) {
          this.showElement = {
            province: true,
            city: true,
            district: true
          }
        }
        this.currentValue = this.value ? this.value : []
      } else if (this.filed.fieldType === 'SELECT') {
        if (this.filed.optionsEnum === 'hospital' || this.filed.optionsEnum === 'lifeExperienceHall' || this.filed.optionsEnum === 'lifeExperienceHallVisit') {
          this.currentValue = this.value && this.value.id
        } else {
          this.currentValue = this.value
        }
        // }
      } else if (this.filed.optionsEnum === 'storageTime') {
        this.pickerOptionsStart = {
          disabledDate: time => {
            let now = new Date()
            let endTime = new Date(
              now.getFullYear(),
              now.getMonth() + 1, 0)
            if (time > endTime) {
              return true
            }
          }
        }
        this.dateType = 'month'
      } else {
        this.currentValue = this.value
      }
    },
    setDate (val) {
      this.currentValue = val
      if (this.filed.optionsEnum === 'storageTime') {
        return
      }
      this.$emit('dateSubmit', val, this.filed.key)
    }
  }
}
</script>
<style module lang="less">

  @import '~less/var.less';
  .date-icon{
    color: @themeColor;
  }
    .address-selector {
      justify-content: space-between;
      // height: 36px;
      // line-height: 36px;
      padding-top: .3rem;
    }
     .addressIcon{
   color: @themeColor;
  //  width: 95% !important;
  margin-right: .5rem
 }
</style>
